export const en = {
  titleImg: 'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/14227b43-8d79-4f56-8b81-8aaacc233996.png',
};

export const ja = {
  titleImg: 'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/f0a6ee96-46a0-4eb0-9f93-b88a57bf7c85.png',
};
